import { render } from "./CustomerHistory.vue?vue&type=template&id=0869cb95&scoped=true"
import script from "./CustomerHistory.vue?vue&type=script&lang=js"
export * from "./CustomerHistory.vue?vue&type=script&lang=js"

import "./CustomerHistory.vue?vue&type=style&index=0&id=0869cb95&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0869cb95"]])

export default __exports__